/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
 * Environment configuration constants loaded from process.env.
 * Contains base URLs and API keys for external service communication.
 */
export const EnvConstants = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
};

/**
 * Authentication verification method constants.
 * Defines supported verification types for user authentication.
 */
export enum VerificationConstants {
  VERIFICATION_BASIC_AUTH = "BASIC_AUTH",
  VERIFICATION_TWO_FACTOR = "TWO_FACTOR",
}
